export enum HomeSectionTitleEnum {
  RelatedProduct = '지금 이 상품 어때요?',
  EndTimeSale = '타임 세일 종료',
  WaitTimeSale = '타임 세일 예정',
  WeeklyBest = '이번 주 베스트 아이템',
  NewArrivals = '따끈따끈 신상품',
  BrandShop = '브랜드 샵',
  FrequentlyBought = '자주 사는 상품',
}
